import defImg from "@/assets/images/local.png";

/**
 * base 00000610
 * style 10000136
 *
 */

export const entry = {
  base: {
    character: {
      name: { key: "00000001", type: "text", value: "角色名称" },
      nameCode: { key: "00000611", type: "text", value: "角色代码" },
      level: { key: "00000002", type: "image", value: defImg },
      nameCode: { key: "00000611", type: "text", value: "nameCode" },
      levelText: { key: "00000612", type: "text", value: "稀有度" },
      cv: { key: "00000003", type: "text", value: "CV名称" },
      jd: {
        icon: { key: "00000004", type: "image", value: defImg },
        text: { key: "00000005", type: "text", value: "描述" }
      },
      sx: {
        icon: { key: "00000006", type: "image", value: defImg },
        text: { key: "00000007", type: "text", value: "描述" }
      },
      zy: {
        icon: { key: "00000008", type: "image", value: defImg },
        text: { key: "00000009", type: "text", value: "描述" }
      },
      qy: {
        icon: { key: "00000010", type: "image", value: defImg },
        text: { key: "00000011", type: "text", value: "描述" }
      },
      bd: {
        icon: { key: "00000012", type: "image", value: defImg },
        text: { key: "00000013", type: "text", value: "描述" }
      },
      szrq: {
        icon: { key: "00000014", type: "image", value: defImg },
        text: { key: "00000569", type: "text", value: "描述" }
      },
      wq: {
        icon: { key: "00000015", type: "image", value: defImg },
        text: { key: "00000016", type: "text", value: "描述" }
      },
      js: {
        icon: { key: "00000017", type: "image", value: defImg },
        text: { key: "00000018", type: "text", value: "描述" }
      },
    },
    force: {
      name: { key: "00000019", type: "text", value: "部队名称" },
      desc: { key: "00000020", type: "text", value: "部队描述" },
      member: {
        member1: {
          name: { key: "00000021", type: "text", value: "成员名称" },
          cover: { key: "00000022", type: "image", value: defImg },
          link: { key: "00000023", type: "text", value: "" }
        },
        member2: {
          name: { key: "00000024", type: "text", value: "成员名称" },
          cover: { key: "00000025", type: "image", value: defImg },
          link: { key: "00000026", type: "text", value: "" }
        },
        member3: {
          name: { key: "00000027", type: "text", value: "成员名称" },
          cover: { key: "00000028", type: "image", value: defImg },
          link: { key: "00000029", type: "text", value: "" }
        },
        member4: {
          name: { key: "00000030", type: "text", value: "成员名称" },
          cover: { key: "00000031", type: "image", value: defImg },
          link: { key: "00000032", type: "text", value: "" }
        },
        member5: {
          name: { key: "00000033", type: "text", value: "成员名称" },
          cover: { key: "00000034", type: "image", value: defImg },
          link: { key: "00000035", type: "text", value: "" }
        },
        member6: {
          name: { key: "00000036", type: "text", value: "成员名称" },
          cover: { key: "00000037", type: "image", value: defImg },
          link: { key: "00000038", type: "text", value: "" }
        }
      }
    },
    conversation: {
      q1: {
        question: { key: "00000039", type: "text", value: "问题描述" },
        answer100: { key: "00000040", type: "text", value: "100好感度描述" },
        answer120: { key: "00000041", type: "text", value: "120好感度描述" }
      },
      q2: {
        question: { key: "00000042", type: "text", value: "问题描述" },
        answer100: { key: "00000043", type: "text", value: "100好感度描述" },
        answer120: { key: "00000044", type: "text", value: "120好感度描述" }
      },
      q3: {
        question: { key: "00000045", type: "text", value: "问题描述" },
        answer100: { key: "00000046", type: "text", value: "100好感度描述" },
        answer120: { key: "00000047", type: "text", value: "120好感度描述" }
      },
      q4: {
        question: { key: "00000048", type: "text", value: "问题描述" },
        answer100: { key: "00000049", type: "text", value: "100好感度描述" },
        answer120: { key: "00000050", type: "text", value: "120好感度描述" }
      },
      q5: {
        question: { key: "00000051", type: "text", value: "问题描述" },
        answer100: { key: "00000052", type: "text", value: "100好感度描述" },
        answer120: { key: "00000053", type: "text", value: "120好感度描述" }
      },
      q6: {
        question: { key: "00000054", type: "text", value: "问题描述" },
        answer100: { key: "00000055", type: "text", value: "100好感度描述" },
        answer120: { key: "00000056", type: "text", value: "120好感度描述" }
      },
      q7: {
        question: { key: "00000057", type: "text", value: "问题描述" },
        answer100: { key: "00000058", type: "text", value: "100好感度描述" },
        answer120: { key: "00000059", type: "text", value: "120好感度描述" }
      },
      q8: {
        question: { key: "00000060", type: "text", value: "问题描述" },
        answer100: { key: "00000061", type: "text", value: "100好感度描述" },
        answer120: { key: "00000062", type: "text", value: "120好感度描述" }
      },
      q9: {
        question: { key: "00000063", type: "text", value: "问题描述" },
        answer100: { key: "00000064", type: "text", value: "100好感度描述" },
        answer120: { key: "00000065", type: "text", value: "120好感度描述" }
      },
      q10: {
        question: { key: "00000066", type: "text", value: "问题描述" },
        answer100: { key: "00000067", type: "text", value: "100好感度描述" },
        answer120: { key: "00000068", type: "text", value: "120好感度描述" }
      },
      q11: {
        question: { key: "00000069", type: "text", value: "问题描述" },
        answer100: { key: "00000070", type: "text", value: "100好感度描述" },
        answer120: { key: "00000071", type: "text", value: "120好感度描述" }
      },
      q12: {
        question: { key: "00000072", type: "text", value: "问题描述" },
        answer100: { key: "00000073", type: "text", value: "100好感度描述" },
        answer120: { key: "00000074", type: "text", value: "120好感度描述" }
      },
      q13: {
        question: { key: "00000075", type: "text", value: "问题描述" },
        answer100: { key: "00000076", type: "text", value: "100好感度描述" },
        answer120: { key: "00000077", type: "text", value: "120好感度描述" }
      },
      q14: {
        question: { key: "00000078", type: "text", value: "问题描述" },
        answer100: { key: "00000079", type: "text", value: "100好感度描述" },
        answer120: { key: "00000080", type: "text", value: "120好感度描述" }
      },
      q15: {
        question: { key: "00000081", type: "text", value: "问题描述" },
        answer100: { key: "00000082", type: "text", value: "100好感度描述" },
        answer120: { key: "00000083", type: "text", value: "120好感度描述" }
      },
      q16: {
        question: { key: "00000084", type: "text", value: "问题描述" },
        answer100: { key: "00000085", type: "text", value: "100好感度描述" },
        answer120: { key: "00000086", type: "text", value: "120好感度描述" }
      },
      q17: {
        question: { key: "00000087", type: "text", value: "问题描述" },
        answer100: { key: "00000088", type: "text", value: "100好感度描述" },
        answer120: { key: "00000089", type: "text", value: "120好感度描述" }
      },
      q18: {
        question: { key: "00000090", type: "text", value: "问题描述" },
        answer100: { key: "00000091", type: "text", value: "100好感度描述" },
        answer120: { key: "00000092", type: "text", value: "120好感度描述" }
      },
      q19: {
        question: { key: "00000093", type: "text", value: "问题描述" },
        answer100: { key: "00000094", type: "text", value: "100好感度描述" },
        answer120: { key: "00000095", type: "text", value: "120好感度描述" }
      },
      q20: {
        question: { key: "00000096", type: "text", value: "问题描述" },
        answer100: { key: "00000097", type: "text", value: "100好感度描述" },
        answer120: { key: "00000098", type: "text", value: "120好感度描述" }
      }
    },
    videos: {
      v1: {
        source: { key: "00000099", type: "video", value: "" }
      },
      v2: {
        source: { key: "00000100", type: "video", value: "" }
      },
      v3: {
        source: { key: "00000101", type: "video", value: "" }
      },
      v4: {
        source: { key: "00000102", type: "video", value: "" }
      },
      v5: {
        source: { key: "00000103", type: "video", value: "" }
      },
      v6: {
        source: { key: "00000104", type: "video", value: "" }
      }
    },
    attr: {
      name: { key: "00000136", type: "text", value: "面板名称" },
      cover: { key: "00000137", type: "image", value: defImg },
      level: { key: "00000105", type: "text", value: "LV 0" },
      baseAim: {
        label: { key: "00000134", type: "text", value: "名称" },
        value: { key: "00000135", type: "text", value: "0" }
      },
      base: {
        b1: {
          label: { key: "00000106", type: "text", value: "名称" },
          value: { key: "00000107", type: "text", value: "0" }
        },
        b2: {
          label: { key: "00000108", type: "text", value: "名称" },
          value: { key: "00000109", type: "text", value: "0" }
        },
        b3: {
          label: { key: "00000110", type: "text", value: "名称" },
          value: { key: "00000111", type: "text", value: "0" }
        },
        b4: {
          label: { key: "00000112", type: "text", value: "名称" },
          value: { key: "00000113", type: "text", value: "0" }
        }
      },
      detail: {
        d1: {
          label: { key: "00000114", type: "text", value: "名称" },
          value: { key: "00000115", type: "text", value: "0" }
        },
        d2: {
          label: { key: "00000116", type: "text", value: "名称" },
          value: { key: "00000117", type: "text", value: "0" }
        },
        d3: {
          label: { key: "00000118", type: "text", value: "名称" },
          value: { key: "00000119", type: "text", value: "0" }
        },
        d4: {
          label: { key: "00000120", type: "text", value: "名称" },
          value: { key: "00000121", type: "text", value: "0" }
        },
        d5: {
          label: { key: "00000122", type: "text", value: "名称" },
          value: { key: "00000123", type: "text", value: "0" }
        },
        d6: {
          label: { key: "00000124", type: "text", value: "名称" },
          value: { key: "00000125", type: "text", value: "0" }
        },
        d7: {
          label: { key: "00000126", type: "text", value: "名称" },
          value: { key: "00000127", type: "text", value: "0" }
        },
        d8: {
          label: { key: "00000128", type: "text", value: "名称" },
          value: { key: "00000129", type: "text", value: "0" }
        },
        d9: {
          label: { key: "00000130", type: "text", value: "名称" },
          value: { key: "00000131", type: "text", value: "0" }
        },
        d10: {
          label: { key: "00000132", type: "text", value: "名称" },
          value: { key: "00000133", type: "text", value: "0" }
        }
      }
    },
    skill: {
      list: {
        s1: {
          name: { key: "00000138", type: "text", value: "名称" },
          icon: { key: "00000139", type: "image", value: defImg },
          cd: { key: "00000140", type: "text", value: "0" },
          type: { key: "00000141", type: "text", value: "" },
          level: {
            l1: {
              desc: { key: "00000142", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000143", type: "image", value: defImg },
                  num: { key: "00000144", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000145", type: "image", value: defImg },
                  num: { key: "00000146", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000147", type: "image", value: defImg },
                  num: { key: "00000148", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000149", type: "image", value: defImg },
                  num: { key: "00000150", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000151", type: "image", value: defImg },
                  num: { key: "00000152", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000153", type: "image", value: defImg },
                  num: { key: "00000154", type: "text", value: "0" }
                }
              }
            },
            l2: {
              desc: { key: "00000155", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000156", type: "image", value: defImg },
                  num: { key: "00000157", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000158", type: "image", value: defImg },
                  num: { key: "00000159", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000160", type: "image", value: defImg },
                  num: { key: "00000161", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000162", type: "image", value: defImg },
                  num: { key: "00000163", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000164", type: "image", value: defImg },
                  num: { key: "00000165", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000166", type: "image", value: defImg },
                  num: { key: "00000167", type: "text", value: "0" }
                }
              }
            },
            l3: {
              desc: { key: "00000168", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000169", type: "image", value: defImg },
                  num: { key: "00000170", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000171", type: "image", value: defImg },
                  num: { key: "00000172", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000173", type: "image", value: defImg },
                  num: { key: "00000174", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000175", type: "image", value: defImg },
                  num: { key: "00000176", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000177", type: "image", value: defImg },
                  num: { key: "00000178", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000179", type: "image", value: defImg },
                  num: { key: "00000180", type: "text", value: "0" }
                }
              }
            },
            l4: {
              desc: { key: "00000181", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000182", type: "image", value: defImg },
                  num: { key: "00000183", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000184", type: "image", value: defImg },
                  num: { key: "00000185", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000186", type: "image", value: defImg },
                  num: { key: "00000187", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000188", type: "image", value: defImg },
                  num: { key: "00000189", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000190", type: "image", value: defImg },
                  num: { key: "00000191", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000192", type: "image", value: defImg },
                  num: { key: "00000193", type: "text", value: "0" }
                }
              }
            },
            l5: {
              desc: { key: "00000194", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000195", type: "image", value: defImg },
                  num: { key: "00000196", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000197", type: "image", value: defImg },
                  num: { key: "00000198", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000199", type: "image", value: defImg },
                  num: { key: "00000200", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000201", type: "image", value: defImg },
                  num: { key: "00000202", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000203", type: "image", value: defImg },
                  num: { key: "00000204", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000205", type: "image", value: defImg },
                  num: { key: "00000206", type: "text", value: "0" }
                }
              }
            },
            l6: {
              desc: { key: "00000207", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000208", type: "image", value: defImg },
                  num: { key: "00000209", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000210", type: "image", value: defImg },
                  num: { key: "00000211", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000212", type: "image", value: defImg },
                  num: { key: "00000213", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000214", type: "image", value: defImg },
                  num: { key: "00000215", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000216", type: "image", value: defImg },
                  num: { key: "00000217", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000218", type: "image", value: defImg },
                  num: { key: "00000219", type: "text", value: "0" }
                }
              }
            },
            l7: {
              desc: { key: "00000220", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000221", type: "image", value: defImg },
                  num: { key: "00000222", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000223", type: "image", value: defImg },
                  num: { key: "00000224", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000225", type: "image", value: defImg },
                  num: { key: "00000226", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000227", type: "image", value: defImg },
                  num: { key: "00000228", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000229", type: "image", value: defImg },
                  num: { key: "00000230", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000231", type: "image", value: defImg },
                  num: { key: "00000232", type: "text", value: "0" }
                }
              }
            },
            l8: {
              desc: { key: "00000233", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000234", type: "image", value: defImg },
                  num: { key: "00000235", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000236", type: "image", value: defImg },
                  num: { key: "00000237", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000238", type: "image", value: defImg },
                  num: { key: "00000239", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000240", type: "image", value: defImg },
                  num: { key: "00000241", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000242", type: "image", value: defImg },
                  num: { key: "00000243", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000244", type: "image", value: defImg },
                  num: { key: "00000245", type: "text", value: "0" }
                }
              }
            },
            l9: {
              desc: { key: "00000246", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000247", type: "image", value: defImg },
                  num: { key: "00000248", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000249", type: "image", value: defImg },
                  num: { key: "00000250", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000251", type: "image", value: defImg },
                  num: { key: "00000252", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000253", type: "image", value: defImg },
                  num: { key: "00000254", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000255", type: "image", value: defImg },
                  num: { key: "00000256", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000257", type: "image", value: defImg },
                  num: { key: "00000258", type: "text", value: "0" }
                }
              }
            },
            l10: {
              desc: { key: "00000259", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000260", type: "image", value: defImg },
                  num: { key: "00000261", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000262", type: "image", value: defImg },
                  num: { key: "00000263", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000264", type: "image", value: defImg },
                  num: { key: "00000265", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000266", type: "image", value: defImg },
                  num: { key: "00000267", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000268", type: "image", value: defImg },
                  num: { key: "00000269", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000270", type: "image", value: defImg },
                  num: { key: "00000271", type: "text", value: "0" }
                }
              }
            }
          },
          zpqh: {
            desc: { key: "00000272", type: "text", value: "珍品强化描述" }
          }
        },
        s2: {
          name: { key: "00000273", type: "text", value: "名称" },
          icon: { key: "00000274", type: "image", value: defImg },
          cd: { key: "00000275", type: "text", value: "0" },
          type: { key: "00000276", type: "text", value: "" },
          level: {
            l1: {
              desc: { key: "00000277", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000278", type: "image", value: defImg },
                  num: { key: "00000279", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000280", type: "image", value: defImg },
                  num: { key: "00000281", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000282", type: "image", value: defImg },
                  num: { key: "00000283", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000284", type: "image", value: defImg },
                  num: { key: "00000285", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000286", type: "image", value: defImg },
                  num: { key: "00000287", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000288", type: "image", value: defImg },
                  num: { key: "00000289", type: "text", value: "0" }
                }
              }
            },
            l2: {
              desc: { key: "00000290", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000291", type: "image", value: defImg },
                  num: { key: "00000292", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000293", type: "image", value: defImg },
                  num: { key: "00000294", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000295", type: "image", value: defImg },
                  num: { key: "00000296", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000297", type: "image", value: defImg },
                  num: { key: "00000298", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000299", type: "image", value: defImg },
                  num: { key: "00000300", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000301", type: "image", value: defImg },
                  num: { key: "00000302", type: "text", value: "0" }
                }
              }
            },
            l3: {
              desc: { key: "00000303", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000304", type: "image", value: defImg },
                  num: { key: "00000305", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000306", type: "image", value: defImg },
                  num: { key: "00000307", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000308", type: "image", value: defImg },
                  num: { key: "00000309", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000310", type: "image", value: defImg },
                  num: { key: "00000311", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000312", type: "image", value: defImg },
                  num: { key: "00000313", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000314", type: "image", value: defImg },
                  num: { key: "00000315", type: "text", value: "0" }
                }
              }
            },
            l4: {
              desc: { key: "00000316", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000317", type: "image", value: defImg },
                  num: { key: "00000318", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000319", type: "image", value: defImg },
                  num: { key: "00000320", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000321", type: "image", value: defImg },
                  num: { key: "00000322", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000323", type: "image", value: defImg },
                  num: { key: "00000324", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000325", type: "image", value: defImg },
                  num: { key: "00000326", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000327", type: "image", value: defImg },
                  num: { key: "00000328", type: "text", value: "0" }
                }
              }
            },
            l5: {
              desc: { key: "00000329", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000330", type: "image", value: defImg },
                  num: { key: "00000331", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000332", type: "image", value: defImg },
                  num: { key: "00000333", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000334", type: "image", value: defImg },
                  num: { key: "00000335", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000336", type: "image", value: defImg },
                  num: { key: "00000337", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000338", type: "image", value: defImg },
                  num: { key: "00000339", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000340", type: "image", value: defImg },
                  num: { key: "00000341", type: "text", value: "0" }
                }
              }
            },
            l6: {
              desc: { key: "00000342", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000343", type: "image", value: defImg },
                  num: { key: "00000344", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000345", type: "image", value: defImg },
                  num: { key: "00000346", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000347", type: "image", value: defImg },
                  num: { key: "00000348", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000349", type: "image", value: defImg },
                  num: { key: "00000350", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000351", type: "image", value: defImg },
                  num: { key: "00000352", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000353", type: "image", value: defImg },
                  num: { key: "00000354", type: "text", value: "0" }
                }
              }
            },
            l7: {
              desc: { key: "00000355", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000356", type: "image", value: defImg },
                  num: { key: "00000357", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000358", type: "image", value: defImg },
                  num: { key: "00000359", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000360", type: "image", value: defImg },
                  num: { key: "00000361", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000362", type: "image", value: defImg },
                  num: { key: "00000363", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000364", type: "image", value: defImg },
                  num: { key: "00000365", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000366", type: "image", value: defImg },
                  num: { key: "00000367", type: "text", value: "0" }
                }
              }
            },
            l8: {
              desc: { key: "00000368", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000369", type: "image", value: defImg },
                  num: { key: "00000370", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000371", type: "image", value: defImg },
                  num: { key: "00000372", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000373", type: "image", value: defImg },
                  num: { key: "00000374", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000375", type: "image", value: defImg },
                  num: { key: "00000376", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000377", type: "image", value: defImg },
                  num: { key: "00000378", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000570", type: "image", value: defImg },
                  num: { key: "00000379", type: "text", value: "0" }
                }
              }
            },
            l9: {
              desc: { key: "00000380", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000381", type: "image", value: defImg },
                  num: { key: "00000382", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000383", type: "image", value: defImg },
                  num: { key: "00000384", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000385", type: "image", value: defImg },
                  num: { key: "00000386", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000387", type: "image", value: defImg },
                  num: { key: "00000388", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000389", type: "image", value: defImg },
                  num: { key: "00000390", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000391", type: "image", value: defImg },
                  num: { key: "00000392", type: "text", value: "0" }
                }
              }
            },
            l10: {
              desc: { key: "00000393", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000394", type: "image", value: defImg },
                  num: { key: "00000395", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000396", type: "image", value: defImg },
                  num: { key: "00000397", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000398", type: "image", value: defImg },
                  num: { key: "00000399", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000400", type: "image", value: defImg },
                  num: { key: "00000401", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000402", type: "image", value: defImg },
                  num: { key: "00000403", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000404", type: "image", value: defImg },
                  num: { key: "00000405", type: "text", value: "0" }
                }
              }
            }
          },
          zpqh: {
            desc: { key: "00000406", type: "text", value: "珍品强化描述" }
          }
        },
        s3: {
          name: { key: "00000407", type: "text", value: "名称" },
          icon: { key: "00000408", type: "image", value: defImg },
          cd: { key: "00000409", type: "text", value: "0" },
          type: { key: "00000410", type: "text", value: "" },
          level: {
            l1: {
              desc: { key: "00000411", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000412", type: "image", value: defImg },
                  num: { key: "00000413", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000414", type: "image", value: defImg },
                  num: { key: "00000415", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000416", type: "image", value: defImg },
                  num: { key: "00000417", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000418", type: "image", value: defImg },
                  num: { key: "00000419", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000420", type: "image", value: defImg },
                  num: { key: "00000421", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000422", type: "image", value: defImg },
                  num: { key: "00000423", type: "text", value: "0" }
                }
              }
            },
            l2: {
              desc: { key: "00000424", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000425", type: "image", value: defImg },
                  num: { key: "00000426", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000427", type: "image", value: defImg },
                  num: { key: "00000428", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000429", type: "image", value: defImg },
                  num: { key: "00000430", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000431", type: "image", value: defImg },
                  num: { key: "00000432", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000433", type: "image", value: defImg },
                  num: { key: "00000434", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000435", type: "image", value: defImg },
                  num: { key: "00000436", type: "text", value: "0" }
                }
              }
            },
            l3: {
              desc: { key: "00000437", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000438", type: "image", value: defImg },
                  num: { key: "00000439", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000440", type: "image", value: defImg },
                  num: { key: "00000441", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000442", type: "image", value: defImg },
                  num: { key: "00000443", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000444", type: "image", value: defImg },
                  num: { key: "00000445", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000446", type: "image", value: defImg },
                  num: { key: "00000447", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000448", type: "image", value: defImg },
                  num: { key: "00000449", type: "text", value: "0" }
                }
              }
            },
            l4: {
              desc: { key: "00000450", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000451", type: "image", value: defImg },
                  num: { key: "00000452", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000453", type: "image", value: defImg },
                  num: { key: "00000454", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000455", type: "image", value: defImg },
                  num: { key: "00000456", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000457", type: "image", value: defImg },
                  num: { key: "00000458", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000459", type: "image", value: defImg },
                  num: { key: "00000460", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000461", type: "image", value: defImg },
                  num: { key: "00000462", type: "text", value: "0" }
                }
              }
            },
            l5: {
              desc: { key: "00000463", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000464", type: "image", value: defImg },
                  num: { key: "00000465", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000466", type: "image", value: defImg },
                  num: { key: "00000467", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000468", type: "image", value: defImg },
                  num: { key: "00000469", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000470", type: "image", value: defImg },
                  num: { key: "00000471", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000472", type: "image", value: defImg },
                  num: { key: "00000473", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000474", type: "image", value: defImg },
                  num: { key: "00000475", type: "text", value: "0" }
                }
              }
            },
            l6: {
              desc: { key: "00000476", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000478", type: "image", value: defImg },
                  num: { key: "00000479", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000480", type: "image", value: defImg },
                  num: { key: "00000481", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000482", type: "image", value: defImg },
                  num: { key: "00000483", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000484", type: "image", value: defImg },
                  num: { key: "00000485", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000486", type: "image", value: defImg },
                  num: { key: "00000487", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000488", type: "image", value: defImg },
                  num: { key: "00000489", type: "text", value: "0" }
                }
              }
            },
            l7: {
              desc: { key: "00000490", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000491", type: "image", value: defImg },
                  num: { key: "00000492", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000493", type: "image", value: defImg },
                  num: { key: "00000494", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000495", type: "image", value: defImg },
                  num: { key: "00000496", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000497", type: "image", value: defImg },
                  num: { key: "00000498", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000499", type: "image", value: defImg },
                  num: { key: "00000500", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000501", type: "image", value: defImg },
                  num: { key: "00000502", type: "text", value: "0" }
                }
              }
            },
            l8: {
              desc: { key: "00000503", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000504", type: "image", value: defImg },
                  num: { key: "00000505", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000506", type: "image", value: defImg },
                  num: { key: "00000507", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000508", type: "image", value: defImg },
                  num: { key: "00000509", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000510", type: "image", value: defImg },
                  num: { key: "00000511", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000512", type: "image", value: defImg },
                  num: { key: "00000513", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000514", type: "image", value: defImg },
                  num: { key: "00000515", type: "text", value: "0" }
                }
              }
            },
            l9: {
              desc: { key: "00000516", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000517", type: "image", value: defImg },
                  num: { key: "00000518", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000519", type: "image", value: defImg },
                  num: { key: "00000520", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000521", type: "image", value: defImg },
                  num: { key: "00000522", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000523", type: "image", value: defImg },
                  num: { key: "00000524", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000525", type: "image", value: defImg },
                  num: { key: "00000526", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000527", type: "image", value: defImg },
                  num: { key: "00000528", type: "text", value: "0" }
                }
              }
            },
            l10: {
              desc: { key: "00000529", type: "text", value: "技能描述" },
              upgrade: {
                u1: {
                  icon: { key: "00000530", type: "image", value: defImg },
                  num: { key: "00000531", type: "text", value: "0" }
                },
                u2: {
                  icon: { key: "00000532", type: "image", value: defImg },
                  num: { key: "00000533", type: "text", value: "0" }
                },
                u3: {
                  icon: { key: "00000534", type: "image", value: defImg },
                  num: { key: "00000535", type: "text", value: "0" }
                },
                u4: {
                  icon: { key: "00000536", type: "image", value: defImg },
                  num: { key: "00000537", type: "text", value: "0" }
                },
                u5: {
                  icon: { key: "00000538", type: "image", value: defImg },
                  num: { key: "00000539", type: "text", value: "0" }
                },
                u6: {
                  icon: { key: "00000540", type: "image", value: defImg },
                  num: { key: "00000541", type: "text", value: "0" }
                }
              }
            }
          },
          zpqh: {
            desc: { key: "00000542", type: "text", value: "珍品强化描述" }
          }
        }
      },
      ptgj: {
        icon: { key: "00000543", type: "image", value: defImg },
        name: { key: "00000544", type: "text", value: "普通攻击" },
        weapon: {
          icon: { key: "00000555", type: "image", value: defImg },
          name: { key: "00000556", type: "text", value: "名称" }
        },
        list: {
          l1: {
            label: { key: "00000545", type: "text", value: "名称" },
            value: { key: "00000546", type: "text", value: "描述" }
          },
          l2: {
            label: { key: "00000547", type: "text", value: "名称" },
            value: { key: "00000548", type: "text", value: "描述" }
          },
          l3: {
            label: { key: "00000549", type: "text", value: "名称" },
            value: { key: "00000550", type: "text", value: "描述" }
          },
          l4: {
            label: { key: "00000551", type: "text", value: "名称" },
            value: { key: "00000552", type: "text", value: "描述" }
          },
          l5: {
            label: { key: "00000553", type: "text", value: "名称" },
            value: { key: "00000554", type: "text", value: "描述" }
          }
        }
      },
      zcp: {
        icon: { key: "00000557", type: "image", value: defImg },
        name: { key: "00000558", type: "text", value: "珍藏品" },
        weapon: {
          icon: { key: "00000559", type: "image", value: defImg },
          level: { key: "00000568", type: "image", value: defImg },
          name: { key: "00000560", type: "text", value: "名称" }
        },
        list: {
          l1: {
            label: { key: "00000561", type: "text", value: "名称" },
            value: { key: "00000562", type: "text", value: "描述" }
          },
          l2: {
            label: { key: "00000563", type: "text", value: "名称" },
            value: { key: "00000564", type: "text", value: "描述" }
          },
          l3: {
            label: { key: "00000565", type: "text", value: "名称" },
            value: { key: "00000566", type: "text", value: "描述" }
          }
        },
        desc: { key: "00000567", type: "text", value: "名称" }
      }
    },
    // 名词解释
    notes: {
      n1: {
        label: { key: "00000571", type: "text", value: "名称" },
        value: { key: "00000572", type: "text", value: "描述" }
      },
      n2: {
        label: { key: "00000573", type: "text", value: "名称" },
        value: { key: "00000574", type: "text", value: "描述" }
      },
      n3: {
        label: { key: "00000575", type: "text", value: "名称" },
        value: { key: "00000576", type: "text", value: "描述" }
      },
      n4: {
        label: { key: "00000577", type: "text", value: "名称" },
        value: { key: "00000578", type: "text", value: "描述" }
      },
      n5: {
        label: { key: "00000579", type: "text", value: "名称" },
        value: { key: "00000580", type: "text", value: "描述" }
      },
      n6: {
        label: { key: "00000581", type: "text", value: "名称" },
        value: { key: "00000582", type: "text", value: "描述" }
      },
      n7: {
        label: { key: "00000583", type: "text", value: "名称" },
        value: { key: "00000584", type: "text", value: "描述" }
      },
      n8: {
        label: { key: "00000585", type: "text", value: "名称" },
        value: { key: "00000586", type: "text", value: "描述" }
      },
      n9: {
        label: { key: "00000587", type: "text", value: "名称" },
        value: { key: "00000588", type: "text", value: "描述" }
      },
      n10: {
        label: { key: "00000589", type: "text", value: "名称" },
        value: { key: "00000590", type: "text", value: "描述" }
      },
      n11: {
        label: { key: "00000591", type: "text", value: "名称" },
        value: { key: "00000592", type: "text", value: "描述" }
      },
      n12: {
        label: { key: "00000593", type: "text", value: "名称" },
        value: { key: "00000594", type: "text", value: "描述" }
      },
      n13: {
        label: { key: "00000595", type: "text", value: "名称" },
        value: { key: "00000596", type: "text", value: "描述" }
      },
      n14: {
        label: { key: "00000597", type: "text", value: "名称" },
        value: { key: "00000598", type: "text", value: "描述" }
      },
      n15: {
        label: { key: "00000599", type: "text", value: "名称" },
        value: { key: "00000600", type: "text", value: "描述" }
      },
      n16: {
        label: { key: "00000601", type: "text", value: "名称" },
        value: { key: "00000602", type: "text", value: "描述" }
      },
      n17: {
        label: { key: "00000603", type: "text", value: "名称" },
        value: { key: "00000604", type: "text", value: "描述" }
      },
      n18: {
        label: { key: "00000605", type: "text", value: "名称" },
        value: { key: "00000606", type: "text", value: "描述" }
      },
      n19: {
        label: { key: "00000607", type: "text", value: "名称" },
        value: { key: "00000608", type: "text", value: "描述" }
      },
      n20: {
        label: { key: "00000609", type: "text", value: "名称" },
        value: { key: "00000610", type: "text", value: "描述" }
      }
    }
  },
  style: {
    style1: {
      name: { key: "10000001", type: "text", value: "时装名称" },
      cover: { key: "10000002", type: "image", value: defImg },
      desc: { key: "10000003", type: "text", value: "时装描述" },
      live2d: {
        full: {
          source: { key: "10000004", type: "live2d", value: { skel: "", atlas: "" } }
        },
        aim: {
          source: { key: "10000005", type: "live2d", value: { skel: "", atlas: "" } }
        },
        cover: {
          source: { key: "10000006", type: "live2d", value: { skel: "", atlas: "" } }
        }
      },
      lh: { key: "10000007", type: "image", value: defImg },
      SDModel: { key: "10000008", type: "image", value: defImg },
      dzdh: { key: "10000009", type: "image", value: defImg },
      voices: {
        dt: {
          voices1: {
            source: { key: "10000010", type: "audio", value: "" },
            label: { key: "10000011", type: "text", value: "名称" },
            desc: { key: "10000012", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "10000013", type: "audio", value: "" },
            label: { key: "10000014", type: "text", value: "名称" },
            desc: { key: "10000015", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "10000016", type: "audio", value: "" },
            label: { key: "10000017", type: "text", value: "名称" },
            desc: { key: "10000018", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "10000019", type: "audio", value: "" },
            label: { key: "10000020", type: "text", value: "名称" },
            desc: { key: "10000021", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "10000022", type: "audio", value: "" },
            label: { key: "10000023", type: "text", value: "名称" },
            desc: { key: "10000024", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "10000025", type: "audio", value: "" },
            label: { key: "10000026", type: "text", value: "名称" },
            desc: { key: "10000027", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "10000028", type: "audio", value: "" },
            label: { key: "10000029", type: "text", value: "名称" },
            desc: { key: "10000030", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "10000031", type: "audio", value: "" },
            label: { key: "10000032", type: "text", value: "名称" },
            desc: { key: "10000033", type: "text", value: "描述" }
          }
        },
        qsjd: {
          voices1: {
            source: { key: "10000034", type: "audio", value: "" },
            label: { key: "10000035", type: "text", value: "名称" },
            desc: { key: "10000036", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "10000037", type: "audio", value: "" },
            label: { key: "10000038", type: "text", value: "名称" },
            desc: { key: "10000039", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "10000040", type: "audio", value: "" },
            label: { key: "10000041", type: "text", value: "名称" },
            desc: { key: "10000042", type: "text", value: "描述" }
          }
        },
        hdycz: {
          voices1: {
            source: { key: "10000043", type: "audio", value: "" },
            label: { key: "10000044", type: "text", value: "名称" },
            desc: { key: "10000045", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "10000046", type: "audio", value: "" },
            label: { key: "10000047", type: "text", value: "名称" },
            desc: { key: "10000048", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "10000049", type: "audio", value: "" },
            label: { key: "10000050", type: "text", value: "名称" },
            desc: { key: "10000051", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "10000052", type: "audio", value: "" },
            label: { key: "10000053", type: "text", value: "名称" },
            desc: { key: "10000054", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "10000055", type: "audio", value: "" },
            label: { key: "10000056", type: "text", value: "名称" },
            desc: { key: "10000057", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "10000058", type: "audio", value: "" },
            label: { key: "10000059", type: "text", value: "名称" },
            desc: { key: "10000060", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "10000061", type: "audio", value: "" },
            label: { key: "10000062", type: "text", value: "名称" },
            desc: { key: "10000063", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "10000064", type: "audio", value: "" },
            label: { key: "10000065", type: "text", value: "名称" },
            desc: { key: "10000066", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "10000067", type: "audio", value: "" },
            label: { key: "10000068", type: "text", value: "名称" },
            desc: { key: "10000069", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "10000070", type: "audio", value: "" },
            label: { key: "10000071", type: "text", value: "名称" },
            desc: { key: "10000072", type: "text", value: "描述" }
          }
        },
        yw: {
          voices1: {
            source: { key: "10000073", type: "audio", value: "" },
            label: { key: "10000074", type: "text", value: "名称" },
            desc: { key: "10000075", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "10000076", type: "audio", value: "" },
            label: { key: "10000077", type: "text", value: "名称" },
            desc: { key: "10000078", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "10000079", type: "audio", value: "" },
            label: { key: "10000080", type: "text", value: "名称" },
            desc: { key: "10000081", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "10000082", type: "audio", value: "" },
            label: { key: "10000083", type: "text", value: "名称" },
            desc: { key: "10000084", type: "text", value: "描述" }
          }
        },
        zd: {
          voices1: {
            source: { key: "10000085", type: "audio", value: "" },
            label: { key: "10000086", type: "text", value: "名称" },
            desc: { key: "10000087", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "10000088", type: "audio", value: "" },
            label: { key: "10000089", type: "text", value: "名称" },
            desc: { key: "10000090", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "10000091", type: "audio", value: "" },
            label: { key: "10000092", type: "text", value: "名称" },
            desc: { key: "10000093", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "10000094", type: "audio", value: "" },
            label: { key: "10000095", type: "text", value: "名称" },
            desc: { key: "10000096", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "10000097", type: "audio", value: "" },
            label: { key: "10000098", type: "text", value: "名称" },
            desc: { key: "10000099", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "10000100", type: "audio", value: "" },
            label: { key: "10000101", type: "text", value: "名称" },
            desc: { key: "10000102", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "10000103", type: "audio", value: "" },
            label: { key: "10000104", type: "text", value: "名称" },
            desc: { key: "10000105", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "10000106", type: "audio", value: "" },
            label: { key: "10000107", type: "text", value: "名称" },
            desc: { key: "10000108", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "10000109", type: "audio", value: "" },
            label: { key: "10000110", type: "text", value: "名称" },
            desc: { key: "10000111", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "10000112", type: "audio", value: "" },
            label: { key: "10000113", type: "text", value: "名称" },
            desc: { key: "10000114", type: "text", value: "描述" }
          },
          voices11: {
            source: { key: "10000115", type: "audio", value: "" },
            label: { key: "10000116", type: "text", value: "名称" },
            desc: { key: "10000117", type: "text", value: "描述" }
          },
          voices12: {
            source: { key: "10000118", type: "audio", value: "" },
            label: { key: "10000119", type: "text", value: "名称" },
            desc: { key: "10000120", type: "text", value: "描述" }
          },
          voices13: {
            source: { key: "10000121", type: "audio", value: "" },
            label: { key: "10000122", type: "text", value: "名称" },
            desc: { key: "10000123", type: "text", value: "描述" }
          },
          voices14: {
            source: { key: "10000124", type: "audio", value: "" },
            label: { key: "10000125", type: "text", value: "名称" },
            desc: { key: "10000126", type: "text", value: "描述" }
          },
          voices15: {
            source: { key: "10000127", type: "audio", value: "" },
            label: { key: "10000128", type: "text", value: "名称" },
            desc: { key: "10000129", type: "text", value: "描述" }
          },
          voices16: {
            source: { key: "10000130", type: "audio", value: "" },
            label: { key: "10000131", type: "text", value: "名称" },
            desc: { key: "10000132", type: "text", value: "描述" }
          },
          voices17: {
            source: { key: "10000133", type: "audio", value: "" },
            label: { key: "10000134", type: "text", value: "名称" },
            desc: { key: "10000135", type: "text", value: "描述" }
          }
        }
      },
      slogan: { key: "10000136", type: "text", value: "时装描述" }
    },
    style2: {
      name: { key: "20000001", type: "text", value: "时装名称" },
      cover: { key: "20000002", type: "image", value: defImg },
      desc: { key: "20000003", type: "text", value: "时装描述" },
      live2d: {
        full: {
          source: { key: "20000004", type: "live2d", value: { skel: "", atlas: "" } }
        },
        aim: {
          source: { key: "20000005", type: "live2d", value: { skel: "", atlas: "" } }
        },
        cover: {
          source: { key: "20000006", type: "live2d", value: { skel: "", atlas: "" } }
        }
      },
      lh: { key: "20000007", type: "image", value: defImg },
      SDModel: { key: "20000008", type: "image", value: defImg },
      dzdh: { key: "20000009", type: "image", value: defImg },
      voices: {
        dt: {
          voices1: {
            source: { key: "20000010", type: "audio", value: "" },
            label: { key: "20000011", type: "text", value: "名称" },
            desc: { key: "20000012", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "20000013", type: "audio", value: "" },
            label: { key: "20000014", type: "text", value: "名称" },
            desc: { key: "20000015", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "20000016", type: "audio", value: "" },
            label: { key: "20000017", type: "text", value: "名称" },
            desc: { key: "20000018", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "20000019", type: "audio", value: "" },
            label: { key: "20000020", type: "text", value: "名称" },
            desc: { key: "20000021", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "20000022", type: "audio", value: "" },
            label: { key: "20000023", type: "text", value: "名称" },
            desc: { key: "20000024", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "20000025", type: "audio", value: "" },
            label: { key: "20000026", type: "text", value: "名称" },
            desc: { key: "20000027", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "20000028", type: "audio", value: "" },
            label: { key: "20000029", type: "text", value: "名称" },
            desc: { key: "20000030", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "20000031", type: "audio", value: "" },
            label: { key: "20000032", type: "text", value: "名称" },
            desc: { key: "20000033", type: "text", value: "描述" }
          }
        },
        qsjd: {
          voices1: {
            source: { key: "20000034", type: "audio", value: "" },
            label: { key: "20000035", type: "text", value: "名称" },
            desc: { key: "20000036", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "20000037", type: "audio", value: "" },
            label: { key: "20000038", type: "text", value: "名称" },
            desc: { key: "20000039", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "20000040", type: "audio", value: "" },
            label: { key: "20000041", type: "text", value: "名称" },
            desc: { key: "20000042", type: "text", value: "描述" }
          }
        },
        hdycz: {
          voices1: {
            source: { key: "20000043", type: "audio", value: "" },
            label: { key: "20000044", type: "text", value: "名称" },
            desc: { key: "20000045", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "20000046", type: "audio", value: "" },
            label: { key: "20000047", type: "text", value: "名称" },
            desc: { key: "20000048", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "20000049", type: "audio", value: "" },
            label: { key: "20000050", type: "text", value: "名称" },
            desc: { key: "20000051", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "20000052", type: "audio", value: "" },
            label: { key: "20000053", type: "text", value: "名称" },
            desc: { key: "20000054", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "20000055", type: "audio", value: "" },
            label: { key: "20000056", type: "text", value: "名称" },
            desc: { key: "20000057", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "20000058", type: "audio", value: "" },
            label: { key: "20000059", type: "text", value: "名称" },
            desc: { key: "20000060", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "20000061", type: "audio", value: "" },
            label: { key: "20000062", type: "text", value: "名称" },
            desc: { key: "20000063", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "20000064", type: "audio", value: "" },
            label: { key: "20000065", type: "text", value: "名称" },
            desc: { key: "20000066", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "20000067", type: "audio", value: "" },
            label: { key: "20000068", type: "text", value: "名称" },
            desc: { key: "20000069", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "20000070", type: "audio", value: "" },
            label: { key: "20000071", type: "text", value: "名称" },
            desc: { key: "20000072", type: "text", value: "描述" }
          }
        },
        yw: {
          voices1: {
            source: { key: "20000073", type: "audio", value: "" },
            label: { key: "20000074", type: "text", value: "名称" },
            desc: { key: "20000075", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "20000076", type: "audio", value: "" },
            label: { key: "20000077", type: "text", value: "名称" },
            desc: { key: "20000078", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "20000079", type: "audio", value: "" },
            label: { key: "20000080", type: "text", value: "名称" },
            desc: { key: "20000081", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "20000082", type: "audio", value: "" },
            label: { key: "20000083", type: "text", value: "名称" },
            desc: { key: "20000084", type: "text", value: "描述" }
          }
        },
        zd: {
          voices1: {
            source: { key: "20000085", type: "audio", value: "" },
            label: { key: "20000086", type: "text", value: "名称" },
            desc: { key: "20000087", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "20000088", type: "audio", value: "" },
            label: { key: "20000089", type: "text", value: "名称" },
            desc: { key: "20000090", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "20000091", type: "audio", value: "" },
            label: { key: "20000092", type: "text", value: "名称" },
            desc: { key: "20000093", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "20000094", type: "audio", value: "" },
            label: { key: "20000095", type: "text", value: "名称" },
            desc: { key: "20000096", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "20000097", type: "audio", value: "" },
            label: { key: "20000098", type: "text", value: "名称" },
            desc: { key: "20000099", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "20000100", type: "audio", value: "" },
            label: { key: "20000101", type: "text", value: "名称" },
            desc: { key: "20000102", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "20000103", type: "audio", value: "" },
            label: { key: "20000104", type: "text", value: "名称" },
            desc: { key: "20000105", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "20000106", type: "audio", value: "" },
            label: { key: "20000107", type: "text", value: "名称" },
            desc: { key: "20000108", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "20000109", type: "audio", value: "" },
            label: { key: "20000110", type: "text", value: "名称" },
            desc: { key: "20000111", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "20000112", type: "audio", value: "" },
            label: { key: "20000113", type: "text", value: "名称" },
            desc: { key: "20000114", type: "text", value: "描述" }
          },
          voices11: {
            source: { key: "20000115", type: "audio", value: "" },
            label: { key: "20000116", type: "text", value: "名称" },
            desc: { key: "20000117", type: "text", value: "描述" }
          },
          voices12: {
            source: { key: "20000118", type: "audio", value: "" },
            label: { key: "20000119", type: "text", value: "名称" },
            desc: { key: "20000120", type: "text", value: "描述" }
          },
          voices13: {
            source: { key: "20000121", type: "audio", value: "" },
            label: { key: "20000122", type: "text", value: "名称" },
            desc: { key: "20000123", type: "text", value: "描述" }
          },
          voices14: {
            source: { key: "20000124", type: "audio", value: "" },
            label: { key: "20000125", type: "text", value: "名称" },
            desc: { key: "20000126", type: "text", value: "描述" }
          },
          voices15: {
            source: { key: "20000127", type: "audio", value: "" },
            label: { key: "20000128", type: "text", value: "名称" },
            desc: { key: "20000129", type: "text", value: "描述" }
          },
          voices16: {
            source: { key: "20000130", type: "audio", value: "" },
            label: { key: "20000131", type: "text", value: "名称" },
            desc: { key: "20000132", type: "text", value: "描述" }
          },
          voices17: {
            source: { key: "20000133", type: "audio", value: "" },
            label: { key: "20000134", type: "text", value: "名称" },
            desc: { key: "20000135", type: "text", value: "描述" }
          }
        }
      },
      slogan: { key: "20000136", type: "text", value: "时装描述" }
    },
    style3: {
      name: { key: "30000001", type: "text", value: "时装名称" },
      cover: { key: "30000002", type: "image", value: defImg },
      desc: { key: "30000003", type: "text", value: "时装描述" },
      live2d: {
        full: {
          source: { key: "30000004", type: "live2d", value: { skel: "", atlas: "" } }
        },
        aim: {
          source: { key: "30000005", type: "live2d", value: { skel: "", atlas: "" } }
        },
        cover: {
          source: { key: "30000006", type: "live2d", value: { skel: "", atlas: "" } }
        }
      },
      lh: { key: "30000007", type: "image", value: defImg },
      SDModel: { key: "30000008", type: "image", value: defImg },
      dzdh: { key: "30000009", type: "image", value: defImg },
      voices: {
        dt: {
          voices1: {
            source: { key: "30000010", type: "audio", value: "" },
            label: { key: "30000011", type: "text", value: "名称" },
            desc: { key: "30000012", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "30000013", type: "audio", value: "" },
            label: { key: "30000014", type: "text", value: "名称" },
            desc: { key: "30000015", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "30000016", type: "audio", value: "" },
            label: { key: "30000017", type: "text", value: "名称" },
            desc: { key: "30000018", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "30000019", type: "audio", value: "" },
            label: { key: "30000020", type: "text", value: "名称" },
            desc: { key: "30000021", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "30000022", type: "audio", value: "" },
            label: { key: "30000023", type: "text", value: "名称" },
            desc: { key: "30000024", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "30000025", type: "audio", value: "" },
            label: { key: "30000026", type: "text", value: "名称" },
            desc: { key: "30000027", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "30000028", type: "audio", value: "" },
            label: { key: "30000029", type: "text", value: "名称" },
            desc: { key: "30000030", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "30000031", type: "audio", value: "" },
            label: { key: "30000032", type: "text", value: "名称" },
            desc: { key: "30000033", type: "text", value: "描述" }
          }
        },
        qsjd: {
          voices1: {
            source: { key: "30000034", type: "audio", value: "" },
            label: { key: "30000035", type: "text", value: "名称" },
            desc: { key: "30000036", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "30000037", type: "audio", value: "" },
            label: { key: "30000038", type: "text", value: "名称" },
            desc: { key: "30000039", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "30000040", type: "audio", value: "" },
            label: { key: "30000041", type: "text", value: "名称" },
            desc: { key: "30000042", type: "text", value: "描述" }
          }
        },
        hdycz: {
          voices1: {
            source: { key: "30000043", type: "audio", value: "" },
            label: { key: "30000044", type: "text", value: "名称" },
            desc: { key: "30000045", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "30000046", type: "audio", value: "" },
            label: { key: "30000047", type: "text", value: "名称" },
            desc: { key: "30000048", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "30000049", type: "audio", value: "" },
            label: { key: "30000050", type: "text", value: "名称" },
            desc: { key: "30000051", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "30000052", type: "audio", value: "" },
            label: { key: "30000053", type: "text", value: "名称" },
            desc: { key: "30000054", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "30000055", type: "audio", value: "" },
            label: { key: "30000056", type: "text", value: "名称" },
            desc: { key: "30000057", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "30000058", type: "audio", value: "" },
            label: { key: "30000059", type: "text", value: "名称" },
            desc: { key: "30000060", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "30000061", type: "audio", value: "" },
            label: { key: "30000062", type: "text", value: "名称" },
            desc: { key: "30000063", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "30000064", type: "audio", value: "" },
            label: { key: "30000065", type: "text", value: "名称" },
            desc: { key: "30000066", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "30000067", type: "audio", value: "" },
            label: { key: "30000068", type: "text", value: "名称" },
            desc: { key: "30000069", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "30000070", type: "audio", value: "" },
            label: { key: "30000071", type: "text", value: "名称" },
            desc: { key: "30000072", type: "text", value: "描述" }
          }
        },
        yw: {
          voices1: {
            source: { key: "30000073", type: "audio", value: "" },
            label: { key: "30000074", type: "text", value: "名称" },
            desc: { key: "30000075", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "30000076", type: "audio", value: "" },
            label: { key: "30000077", type: "text", value: "名称" },
            desc: { key: "30000078", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "30000079", type: "audio", value: "" },
            label: { key: "30000080", type: "text", value: "名称" },
            desc: { key: "30000081", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "30000082", type: "audio", value: "" },
            label: { key: "30000083", type: "text", value: "名称" },
            desc: { key: "30000084", type: "text", value: "描述" }
          }
        },
        zd: {
          voices1: {
            source: { key: "30000085", type: "audio", value: "" },
            label: { key: "30000086", type: "text", value: "名称" },
            desc: { key: "30000087", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "30000088", type: "audio", value: "" },
            label: { key: "30000089", type: "text", value: "名称" },
            desc: { key: "30000090", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "30000091", type: "audio", value: "" },
            label: { key: "30000092", type: "text", value: "名称" },
            desc: { key: "30000093", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "30000094", type: "audio", value: "" },
            label: { key: "30000095", type: "text", value: "名称" },
            desc: { key: "30000096", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "30000097", type: "audio", value: "" },
            label: { key: "30000098", type: "text", value: "名称" },
            desc: { key: "30000099", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "30000100", type: "audio", value: "" },
            label: { key: "30000101", type: "text", value: "名称" },
            desc: { key: "30000102", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "30000103", type: "audio", value: "" },
            label: { key: "30000104", type: "text", value: "名称" },
            desc: { key: "30000105", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "30000106", type: "audio", value: "" },
            label: { key: "30000107", type: "text", value: "名称" },
            desc: { key: "30000108", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "30000109", type: "audio", value: "" },
            label: { key: "30000110", type: "text", value: "名称" },
            desc: { key: "30000111", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "30000112", type: "audio", value: "" },
            label: { key: "30000113", type: "text", value: "名称" },
            desc: { key: "30000114", type: "text", value: "描述" }
          },
          voices11: {
            source: { key: "30000115", type: "audio", value: "" },
            label: { key: "30000116", type: "text", value: "名称" },
            desc: { key: "30000117", type: "text", value: "描述" }
          },
          voices12: {
            source: { key: "30000118", type: "audio", value: "" },
            label: { key: "30000119", type: "text", value: "名称" },
            desc: { key: "30000120", type: "text", value: "描述" }
          },
          voices13: {
            source: { key: "30000121", type: "audio", value: "" },
            label: { key: "30000122", type: "text", value: "名称" },
            desc: { key: "30000123", type: "text", value: "描述" }
          },
          voices14: {
            source: { key: "30000124", type: "audio", value: "" },
            label: { key: "30000125", type: "text", value: "名称" },
            desc: { key: "30000126", type: "text", value: "描述" }
          },
          voices15: {
            source: { key: "30000127", type: "audio", value: "" },
            label: { key: "30000128", type: "text", value: "名称" },
            desc: { key: "30000129", type: "text", value: "描述" }
          },
          voices16: {
            source: { key: "30000130", type: "audio", value: "" },
            label: { key: "30000131", type: "text", value: "名称" },
            desc: { key: "30000132", type: "text", value: "描述" }
          },
          voices17: {
            source: { key: "30000133", type: "audio", value: "" },
            label: { key: "30000134", type: "text", value: "名称" },
            desc: { key: "30000135", type: "text", value: "描述" }
          }
        }
      },
      slogan: { key: "30000136", type: "text", value: "时装描述" }
    },
    style4: {
      name: { key: "40000001", type: "text", value: "时装名称" },
      cover: { key: "40000002", type: "image", value: defImg },
      desc: { key: "40000003", type: "text", value: "时装描述" },
      live2d: {
        full: {
          source: { key: "40000004", type: "live2d", value: { skel: "", atlas: "" } }
        },
        aim: {
          source: { key: "40000005", type: "live2d", value: { skel: "", atlas: "" } }
        },
        cover: {
          source: { key: "40000006", type: "live2d", value: { skel: "", atlas: "" } }
        }
      },
      lh: { key: "40000007", type: "image", value: defImg },
      SDModel: { key: "40000008", type: "image", value: defImg },
      dzdh: { key: "40000009", type: "image", value: defImg },
      voices: {
        dt: {
          voices1: {
            source: { key: "40000010", type: "audio", value: "" },
            label: { key: "40000011", type: "text", value: "名称" },
            desc: { key: "40000012", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "40000013", type: "audio", value: "" },
            label: { key: "40000014", type: "text", value: "名称" },
            desc: { key: "40000015", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "40000016", type: "audio", value: "" },
            label: { key: "40000017", type: "text", value: "名称" },
            desc: { key: "40000018", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "40000019", type: "audio", value: "" },
            label: { key: "40000020", type: "text", value: "名称" },
            desc: { key: "40000021", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "40000022", type: "audio", value: "" },
            label: { key: "40000023", type: "text", value: "名称" },
            desc: { key: "40000024", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "40000025", type: "audio", value: "" },
            label: { key: "40000026", type: "text", value: "名称" },
            desc: { key: "40000027", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "40000028", type: "audio", value: "" },
            label: { key: "40000029", type: "text", value: "名称" },
            desc: { key: "40000030", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "40000031", type: "audio", value: "" },
            label: { key: "40000032", type: "text", value: "名称" },
            desc: { key: "40000033", type: "text", value: "描述" }
          }
        },
        qsjd: {
          voices1: {
            source: { key: "40000034", type: "audio", value: "" },
            label: { key: "40000035", type: "text", value: "名称" },
            desc: { key: "40000036", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "40000037", type: "audio", value: "" },
            label: { key: "40000038", type: "text", value: "名称" },
            desc: { key: "40000039", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "40000040", type: "audio", value: "" },
            label: { key: "40000041", type: "text", value: "名称" },
            desc: { key: "40000042", type: "text", value: "描述" }
          }
        },
        hdycz: {
          voices1: {
            source: { key: "40000043", type: "audio", value: "" },
            label: { key: "40000044", type: "text", value: "名称" },
            desc: { key: "40000045", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "40000046", type: "audio", value: "" },
            label: { key: "40000047", type: "text", value: "名称" },
            desc: { key: "40000048", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "40000049", type: "audio", value: "" },
            label: { key: "40000050", type: "text", value: "名称" },
            desc: { key: "40000051", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "40000052", type: "audio", value: "" },
            label: { key: "40000053", type: "text", value: "名称" },
            desc: { key: "40000054", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "40000055", type: "audio", value: "" },
            label: { key: "40000056", type: "text", value: "名称" },
            desc: { key: "40000057", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "40000058", type: "audio", value: "" },
            label: { key: "40000059", type: "text", value: "名称" },
            desc: { key: "40000060", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "40000061", type: "audio", value: "" },
            label: { key: "40000062", type: "text", value: "名称" },
            desc: { key: "40000063", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "40000064", type: "audio", value: "" },
            label: { key: "40000065", type: "text", value: "名称" },
            desc: { key: "40000066", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "40000067", type: "audio", value: "" },
            label: { key: "40000068", type: "text", value: "名称" },
            desc: { key: "40000069", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "40000070", type: "audio", value: "" },
            label: { key: "40000071", type: "text", value: "名称" },
            desc: { key: "40000072", type: "text", value: "描述" }
          }
        },
        yw: {
          voices1: {
            source: { key: "40000073", type: "audio", value: "" },
            label: { key: "40000074", type: "text", value: "名称" },
            desc: { key: "40000075", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "40000076", type: "audio", value: "" },
            label: { key: "40000077", type: "text", value: "名称" },
            desc: { key: "40000078", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "40000079", type: "audio", value: "" },
            label: { key: "40000080", type: "text", value: "名称" },
            desc: { key: "40000081", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "40000082", type: "audio", value: "" },
            label: { key: "40000083", type: "text", value: "名称" },
            desc: { key: "40000084", type: "text", value: "描述" }
          }
        },
        zd: {
          voices1: {
            source: { key: "40000085", type: "audio", value: "" },
            label: { key: "40000086", type: "text", value: "名称" },
            desc: { key: "40000087", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "40000088", type: "audio", value: "" },
            label: { key: "40000089", type: "text", value: "名称" },
            desc: { key: "40000090", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "40000091", type: "audio", value: "" },
            label: { key: "40000092", type: "text", value: "名称" },
            desc: { key: "40000093", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "40000094", type: "audio", value: "" },
            label: { key: "40000095", type: "text", value: "名称" },
            desc: { key: "40000096", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "40000097", type: "audio", value: "" },
            label: { key: "40000098", type: "text", value: "名称" },
            desc: { key: "40000099", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "40000100", type: "audio", value: "" },
            label: { key: "40000101", type: "text", value: "名称" },
            desc: { key: "40000102", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "40000103", type: "audio", value: "" },
            label: { key: "40000104", type: "text", value: "名称" },
            desc: { key: "40000105", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "40000106", type: "audio", value: "" },
            label: { key: "40000107", type: "text", value: "名称" },
            desc: { key: "40000108", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "40000109", type: "audio", value: "" },
            label: { key: "40000110", type: "text", value: "名称" },
            desc: { key: "40000111", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "40000112", type: "audio", value: "" },
            label: { key: "40000113", type: "text", value: "名称" },
            desc: { key: "40000114", type: "text", value: "描述" }
          },
          voices11: {
            source: { key: "40000115", type: "audio", value: "" },
            label: { key: "40000116", type: "text", value: "名称" },
            desc: { key: "40000117", type: "text", value: "描述" }
          },
          voices12: {
            source: { key: "40000118", type: "audio", value: "" },
            label: { key: "40000119", type: "text", value: "名称" },
            desc: { key: "40000120", type: "text", value: "描述" }
          },
          voices13: {
            source: { key: "40000121", type: "audio", value: "" },
            label: { key: "40000122", type: "text", value: "名称" },
            desc: { key: "40000123", type: "text", value: "描述" }
          },
          voices14: {
            source: { key: "40000124", type: "audio", value: "" },
            label: { key: "40000125", type: "text", value: "名称" },
            desc: { key: "40000126", type: "text", value: "描述" }
          },
          voices15: {
            source: { key: "40000127", type: "audio", value: "" },
            label: { key: "40000128", type: "text", value: "名称" },
            desc: { key: "40000129", type: "text", value: "描述" }
          },
          voices16: {
            source: { key: "40000130", type: "audio", value: "" },
            label: { key: "40000131", type: "text", value: "名称" },
            desc: { key: "40000132", type: "text", value: "描述" }
          },
          voices17: {
            source: { key: "40000133", type: "audio", value: "" },
            label: { key: "40000134", type: "text", value: "名称" },
            desc: { key: "40000135", type: "text", value: "描述" }
          }
        }
      },
      slogan: { key: "40000136", type: "text", value: "时装描述" }
    },
    style5: {
      name: { key: "50000001", type: "text", value: "时装名称" },
      cover: { key: "50000002", type: "image", value: defImg },
      desc: { key: "50000003", type: "text", value: "时装描述" },
      live2d: {
        full: {
          source: { key: "50000004", type: "live2d", value: { skel: "", atlas: "" } }
        },
        aim: {
          source: { key: "50000005", type: "live2d", value: { skel: "", atlas: "" } }
        },
        cover: {
          source: { key: "50000006", type: "live2d", value: { skel: "", atlas: "" } }
        }
      },
      lh: { key: "50000007", type: "image", value: defImg },
      SDModel: { key: "50000008", type: "image", value: defImg },
      dzdh: { key: "50000009", type: "image", value: defImg },
      voices: {
        dt: {
          voices1: {
            source: { key: "50000010", type: "audio", value: "" },
            label: { key: "50000011", type: "text", value: "名称" },
            desc: { key: "50000012", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "50000013", type: "audio", value: "" },
            label: { key: "50000014", type: "text", value: "名称" },
            desc: { key: "50000015", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "50000016", type: "audio", value: "" },
            label: { key: "50000017", type: "text", value: "名称" },
            desc: { key: "50000018", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "50000019", type: "audio", value: "" },
            label: { key: "50000020", type: "text", value: "名称" },
            desc: { key: "50000021", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "50000022", type: "audio", value: "" },
            label: { key: "50000023", type: "text", value: "名称" },
            desc: { key: "50000024", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "50000025", type: "audio", value: "" },
            label: { key: "50000026", type: "text", value: "名称" },
            desc: { key: "50000027", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "50000028", type: "audio", value: "" },
            label: { key: "50000029", type: "text", value: "名称" },
            desc: { key: "50000030", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "50000031", type: "audio", value: "" },
            label: { key: "50000032", type: "text", value: "名称" },
            desc: { key: "50000033", type: "text", value: "描述" }
          }
        },
        qsjd: {
          voices1: {
            source: { key: "50000034", type: "audio", value: "" },
            label: { key: "50000035", type: "text", value: "名称" },
            desc: { key: "50000036", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "50000037", type: "audio", value: "" },
            label: { key: "50000038", type: "text", value: "名称" },
            desc: { key: "50000039", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "50000040", type: "audio", value: "" },
            label: { key: "50000041", type: "text", value: "名称" },
            desc: { key: "50000042", type: "text", value: "描述" }
          }
        },
        hdycz: {
          voices1: {
            source: { key: "50000043", type: "audio", value: "" },
            label: { key: "50000044", type: "text", value: "名称" },
            desc: { key: "50000045", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "50000046", type: "audio", value: "" },
            label: { key: "50000047", type: "text", value: "名称" },
            desc: { key: "50000048", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "50000049", type: "audio", value: "" },
            label: { key: "50000050", type: "text", value: "名称" },
            desc: { key: "50000051", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "50000052", type: "audio", value: "" },
            label: { key: "50000053", type: "text", value: "名称" },
            desc: { key: "50000054", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "50000055", type: "audio", value: "" },
            label: { key: "50000056", type: "text", value: "名称" },
            desc: { key: "50000057", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "50000058", type: "audio", value: "" },
            label: { key: "50000059", type: "text", value: "名称" },
            desc: { key: "50000060", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "50000061", type: "audio", value: "" },
            label: { key: "50000062", type: "text", value: "名称" },
            desc: { key: "50000063", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "50000064", type: "audio", value: "" },
            label: { key: "50000065", type: "text", value: "名称" },
            desc: { key: "50000066", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "50000067", type: "audio", value: "" },
            label: { key: "50000068", type: "text", value: "名称" },
            desc: { key: "50000069", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "50000070", type: "audio", value: "" },
            label: { key: "50000071", type: "text", value: "名称" },
            desc: { key: "50000072", type: "text", value: "描述" }
          }
        },
        yw: {
          voices1: {
            source: { key: "50000073", type: "audio", value: "" },
            label: { key: "50000074", type: "text", value: "名称" },
            desc: { key: "50000075", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "50000076", type: "audio", value: "" },
            label: { key: "50000077", type: "text", value: "名称" },
            desc: { key: "50000078", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "50000079", type: "audio", value: "" },
            label: { key: "50000080", type: "text", value: "名称" },
            desc: { key: "50000081", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "50000082", type: "audio", value: "" },
            label: { key: "50000083", type: "text", value: "名称" },
            desc: { key: "50000084", type: "text", value: "描述" }
          }
        },
        zd: {
          voices1: {
            source: { key: "50000085", type: "audio", value: "" },
            label: { key: "50000086", type: "text", value: "名称" },
            desc: { key: "50000087", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "50000088", type: "audio", value: "" },
            label: { key: "50000089", type: "text", value: "名称" },
            desc: { key: "50000090", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "50000091", type: "audio", value: "" },
            label: { key: "50000092", type: "text", value: "名称" },
            desc: { key: "50000093", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "50000094", type: "audio", value: "" },
            label: { key: "50000095", type: "text", value: "名称" },
            desc: { key: "50000096", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "50000097", type: "audio", value: "" },
            label: { key: "50000098", type: "text", value: "名称" },
            desc: { key: "50000099", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "50000100", type: "audio", value: "" },
            label: { key: "50000101", type: "text", value: "名称" },
            desc: { key: "50000102", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "50000103", type: "audio", value: "" },
            label: { key: "50000104", type: "text", value: "名称" },
            desc: { key: "50000105", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "50000106", type: "audio", value: "" },
            label: { key: "50000107", type: "text", value: "名称" },
            desc: { key: "50000108", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "50000109", type: "audio", value: "" },
            label: { key: "50000110", type: "text", value: "名称" },
            desc: { key: "50000111", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "50000112", type: "audio", value: "" },
            label: { key: "50000113", type: "text", value: "名称" },
            desc: { key: "50000114", type: "text", value: "描述" }
          },
          voices11: {
            source: { key: "50000115", type: "audio", value: "" },
            label: { key: "50000116", type: "text", value: "名称" },
            desc: { key: "50000117", type: "text", value: "描述" }
          },
          voices12: {
            source: { key: "50000118", type: "audio", value: "" },
            label: { key: "50000119", type: "text", value: "名称" },
            desc: { key: "50000120", type: "text", value: "描述" }
          },
          voices13: {
            source: { key: "50000121", type: "audio", value: "" },
            label: { key: "50000122", type: "text", value: "名称" },
            desc: { key: "50000123", type: "text", value: "描述" }
          },
          voices14: {
            source: { key: "50000124", type: "audio", value: "" },
            label: { key: "50000125", type: "text", value: "名称" },
            desc: { key: "50000126", type: "text", value: "描述" }
          },
          voices15: {
            source: { key: "50000127", type: "audio", value: "" },
            label: { key: "50000128", type: "text", value: "名称" },
            desc: { key: "50000129", type: "text", value: "描述" }
          },
          voices16: {
            source: { key: "50000130", type: "audio", value: "" },
            label: { key: "50000131", type: "text", value: "名称" },
            desc: { key: "50000132", type: "text", value: "描述" }
          },
          voices17: {
            source: { key: "50000133", type: "audio", value: "" },
            label: { key: "50000134", type: "text", value: "名称" },
            desc: { key: "50000135", type: "text", value: "描述" }
          }
        }
      },
      slogan: { key: "50000136", type: "text", value: "时装描述" }
    },
    style6: {
      name: { key: "60000001", type: "text", value: "时装名称" },
      cover: { key: "60000002", type: "image", value: defImg },
      desc: { key: "60000003", type: "text", value: "时装描述" },
      live2d: {
        full: {
          source: { key: "60000004", type: "live2d", value: { skel: "", atlas: "" } }
        },
        aim: {
          source: { key: "60000005", type: "live2d", value: { skel: "", atlas: "" } }
        },
        cover: {
          source: { key: "60000006", type: "live2d", value: { skel: "", atlas: "" } }
        }
      },
      lh: { key: "60000007", type: "image", value: defImg },
      SDModel: { key: "60000008", type: "image", value: defImg },
      dzdh: { key: "60000009", type: "image", value: defImg },
      voices: {
        dt: {
          voices1: {
            source: { key: "60000010", type: "audio", value: "" },
            label: { key: "60000011", type: "text", value: "名称" },
            desc: { key: "60000012", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "60000013", type: "audio", value: "" },
            label: { key: "60000014", type: "text", value: "名称" },
            desc: { key: "60000015", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "60000016", type: "audio", value: "" },
            label: { key: "60000017", type: "text", value: "名称" },
            desc: { key: "60000018", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "60000019", type: "audio", value: "" },
            label: { key: "60000020", type: "text", value: "名称" },
            desc: { key: "60000021", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "60000022", type: "audio", value: "" },
            label: { key: "60000023", type: "text", value: "名称" },
            desc: { key: "60000024", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "60000025", type: "audio", value: "" },
            label: { key: "60000026", type: "text", value: "名称" },
            desc: { key: "60000027", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "60000028", type: "audio", value: "" },
            label: { key: "60000029", type: "text", value: "名称" },
            desc: { key: "60000030", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "60000031", type: "audio", value: "" },
            label: { key: "60000032", type: "text", value: "名称" },
            desc: { key: "60000033", type: "text", value: "描述" }
          }
        },
        qsjd: {
          voices1: {
            source: { key: "60000034", type: "audio", value: "" },
            label: { key: "60000035", type: "text", value: "名称" },
            desc: { key: "60000036", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "60000037", type: "audio", value: "" },
            label: { key: "60000038", type: "text", value: "名称" },
            desc: { key: "60000039", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "60000040", type: "audio", value: "" },
            label: { key: "60000041", type: "text", value: "名称" },
            desc: { key: "60000042", type: "text", value: "描述" }
          }
        },
        hdycz: {
          voices1: {
            source: { key: "60000043", type: "audio", value: "" },
            label: { key: "60000044", type: "text", value: "名称" },
            desc: { key: "60000045", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "60000046", type: "audio", value: "" },
            label: { key: "60000047", type: "text", value: "名称" },
            desc: { key: "60000048", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "60000049", type: "audio", value: "" },
            label: { key: "60000050", type: "text", value: "名称" },
            desc: { key: "60000051", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "60000052", type: "audio", value: "" },
            label: { key: "60000053", type: "text", value: "名称" },
            desc: { key: "60000054", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "60000055", type: "audio", value: "" },
            label: { key: "60000056", type: "text", value: "名称" },
            desc: { key: "60000057", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "60000058", type: "audio", value: "" },
            label: { key: "60000059", type: "text", value: "名称" },
            desc: { key: "60000060", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "60000061", type: "audio", value: "" },
            label: { key: "60000062", type: "text", value: "名称" },
            desc: { key: "60000063", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "60000064", type: "audio", value: "" },
            label: { key: "60000065", type: "text", value: "名称" },
            desc: { key: "60000066", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "60000067", type: "audio", value: "" },
            label: { key: "60000068", type: "text", value: "名称" },
            desc: { key: "60000069", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "60000070", type: "audio", value: "" },
            label: { key: "60000071", type: "text", value: "名称" },
            desc: { key: "60000072", type: "text", value: "描述" }
          }
        },
        yw: {
          voices1: {
            source: { key: "60000073", type: "audio", value: "" },
            label: { key: "60000074", type: "text", value: "名称" },
            desc: { key: "60000075", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "60000076", type: "audio", value: "" },
            label: { key: "60000077", type: "text", value: "名称" },
            desc: { key: "60000078", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "60000079", type: "audio", value: "" },
            label: { key: "60000080", type: "text", value: "名称" },
            desc: { key: "60000081", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "60000082", type: "audio", value: "" },
            label: { key: "60000083", type: "text", value: "名称" },
            desc: { key: "60000084", type: "text", value: "描述" }
          }
        },
        zd: {
          voices1: {
            source: { key: "60000085", type: "audio", value: "" },
            label: { key: "60000086", type: "text", value: "名称" },
            desc: { key: "60000087", type: "text", value: "描述" }
          },
          voices2: {
            source: { key: "60000088", type: "audio", value: "" },
            label: { key: "60000089", type: "text", value: "名称" },
            desc: { key: "60000090", type: "text", value: "描述" }
          },
          voices3: {
            source: { key: "60000091", type: "audio", value: "" },
            label: { key: "60000092", type: "text", value: "名称" },
            desc: { key: "60000093", type: "text", value: "描述" }
          },
          voices4: {
            source: { key: "60000094", type: "audio", value: "" },
            label: { key: "60000095", type: "text", value: "名称" },
            desc: { key: "60000096", type: "text", value: "描述" }
          },
          voices5: {
            source: { key: "60000097", type: "audio", value: "" },
            label: { key: "60000098", type: "text", value: "名称" },
            desc: { key: "60000099", type: "text", value: "描述" }
          },
          voices6: {
            source: { key: "60000100", type: "audio", value: "" },
            label: { key: "60000101", type: "text", value: "名称" },
            desc: { key: "60000102", type: "text", value: "描述" }
          },
          voices7: {
            source: { key: "60000103", type: "audio", value: "" },
            label: { key: "60000104", type: "text", value: "名称" },
            desc: { key: "60000105", type: "text", value: "描述" }
          },
          voices8: {
            source: { key: "60000106", type: "audio", value: "" },
            label: { key: "60000107", type: "text", value: "名称" },
            desc: { key: "60000108", type: "text", value: "描述" }
          },
          voices9: {
            source: { key: "60000109", type: "audio", value: "" },
            label: { key: "60000110", type: "text", value: "名称" },
            desc: { key: "60000111", type: "text", value: "描述" }
          },
          voices10: {
            source: { key: "60000112", type: "audio", value: "" },
            label: { key: "60000113", type: "text", value: "名称" },
            desc: { key: "60000114", type: "text", value: "描述" }
          },
          voices11: {
            source: { key: "60000115", type: "audio", value: "" },
            label: { key: "60000116", type: "text", value: "名称" },
            desc: { key: "60000117", type: "text", value: "描述" }
          },
          voices12: {
            source: { key: "60000118", type: "audio", value: "" },
            label: { key: "60000119", type: "text", value: "名称" },
            desc: { key: "60000120", type: "text", value: "描述" }
          },
          voices13: {
            source: { key: "60000121", type: "audio", value: "" },
            label: { key: "60000122", type: "text", value: "名称" },
            desc: { key: "60000123", type: "text", value: "描述" }
          },
          voices14: {
            source: { key: "60000124", type: "audio", value: "" },
            label: { key: "60000125", type: "text", value: "名称" },
            desc: { key: "60000126", type: "text", value: "描述" }
          },
          voices15: {
            source: { key: "60000127", type: "audio", value: "" },
            label: { key: "60000128", type: "text", value: "名称" },
            desc: { key: "60000129", type: "text", value: "描述" }
          },
          voices16: {
            source: { key: "60000130", type: "audio", value: "" },
            label: { key: "60000131", type: "text", value: "名称" },
            desc: { key: "60000132", type: "text", value: "描述" }
          },
          voices17: {
            source: { key: "60000133", type: "audio", value: "" },
            label: { key: "60000134", type: "text", value: "名称" },
            desc: { key: "60000135", type: "text", value: "描述" }
          }
        }
      },
      slogan: { key: "60000136", type: "text", value: "时装描述" }
    }
  }
};

export function checkRepeatKey(entry) {
  const keys = [];
  // 递归处理数据
  function deepMap(dataSource) {
    Object.keys(dataSource).forEach(key => {
      const current = dataSource[key];
      if (typeof current === "object") {
        if (typeof current.key === "string") {
          if (keys.includes(current.key)) {
            console.error("图鉴entry 存在重复key", current.key);
            return;
          }
          keys.push(current.key);
        } else {
          deepMap(current);
        }
      }
    });
  }

  deepMap(entry);
}
